import modal from './modal'
import loader from './loader'

export default {
    ...modal,
    ...loader
}